// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    /*position: relative;*/
    margin-left: auto;
    margin-right: auto;
    animation: rotate 1s linear infinite
}
.loader::before , .loader::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 12.5px solid #f49718;
    animation: prixClipFix 2s linear infinite ;
}
.loader::after{
    inset: 8px;
    transform: rotate3d(90, 90, 0, 180deg );
    border-color: #3f3f3f;
}

@keyframes rotate {
    0%   {transform: rotate(0deg)}
    100%   {transform: rotate(360deg)}
}

@keyframes prixClipFix {
    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
    75%, 100%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,0CAA0C;AAC9C;AACA;IACI,UAAU;IACV,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;IACI,MAAM,uBAAuB;IAC7B,QAAQ,yBAAyB;AACrC;;AAEA;IACI,MAAM,8CAA8C;IACpD,MAAM,0DAA0D;IAChE,YAAY,mEAAmE;AACnF","sourcesContent":[".loader {\r\n    width: 120px;\r\n    height: 120px;\r\n    border-radius: 50%;\r\n    /*position: relative;*/\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    animation: rotate 1s linear infinite\r\n}\r\n.loader::before , .loader::after {\r\n    content: \"\";\r\n    box-sizing: border-box;\r\n    position: absolute;\r\n    inset: 0px;\r\n    border-radius: 50%;\r\n    border: 12.5px solid #f49718;\r\n    animation: prixClipFix 2s linear infinite ;\r\n}\r\n.loader::after{\r\n    inset: 8px;\r\n    transform: rotate3d(90, 90, 0, 180deg );\r\n    border-color: #3f3f3f;\r\n}\r\n\r\n@keyframes rotate {\r\n    0%   {transform: rotate(0deg)}\r\n    100%   {transform: rotate(360deg)}\r\n}\r\n\r\n@keyframes prixClipFix {\r\n    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}\r\n    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}\r\n    75%, 100%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
